import React, { CSSProperties } from 'react';
import { observer } from 'mobx-react';
import Lottie from 'lottie-react';

import loader from './assets/loader.json';

import './styles.scss';

type PropsType = {
    style?: CSSProperties;
};
export const UiLoading = observer(function UiLoading({ style }: PropsType) {
    return (
        <div className="ui-new-loading" style={style}>
            <Lottie style={{ height: 90 }} animationData={loader} />
        </div>
    );
});
